<app-breadcrumb [breadcrumbs]="breadcrumbs$ | async"></app-breadcrumb>

@if (loading$ | async) {
    <ngx-skeleton-loader count="5" appearance="line" [theme]="{height: '64px'}" />
}

<div #contentWrapper id="shadow-rootz"></div>

